import React from "react";
import "./FloatingContact.css";
import { FaWhatsapp, FaPhone } from "react-icons/fa";

const FloatingContact = () => {
  const phone = "9340214828";
  const countryCode = "91";

  return (
    <div className="floating-contact">

      {/* Call Button */}
      <a
        href={`tel:+${countryCode}${phone}`}
        className="call-btn"
      >
        <FaPhone /> {phone}
      </a>

      {/* WhatsApp Button */}
      <a
        href={`https://wa.me/${countryCode}${phone}`}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-btn"
      >
        <FaWhatsapp /> {phone}
      </a>

    </div>
  );
};

export default FloatingContact;